/* import __COLOCATED_TEMPLATE__ from './expired.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './paid_or_expired.module.scss';

export default class SitePaymentLinkExpired extends Component {
  styles = styles;

  @service session;

  get isAuthenticated() {
    return this.session.isAuthenticated;
  }
}
